import { Box, Typography, Stack, useTheme, Link, useMediaQuery } from "@mui/material";
import BubbleOverlay from "@/assets/bubble_overlay.png";
import SMSServicesLogo from "@/assets/sms_services_logo.png";
import {
  Facebook as FacebookIcon,
  PhoneInTalkOutlined as PhoneInTalkIcon,
  EmailOutlined as EmailIcon,
} from "@mui/icons-material";
import { ROUTES } from "@/routes";
import { Link as RouterLink } from "react-router-dom";

const FooterImportantLinksBlock = () => {
  const theme = useTheme();
  return (<Stack direction={"column"} sx={{
    "& > a": {
      color: "white !important",
      fontWeight: "300",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      alignItems: "center",
    },
  }}>
    <Typography variant="h5" fontWeight={"600"} sx={{
      [theme.breakpoints.down("lg")]: {
        fontSize: "20px",
      },
    }}>
      Důležité odkazy
    </Typography>
    <Link variant="h6" to={ROUTES.ABOUT_US} component={RouterLink}>O nás</Link>
    <Link variant="h6" to={ROUTES.ABOUT_PRODUCT} component={RouterLink}>O službě</Link>
    <Link variant="h6" to={ROUTES.CONTACT_US} component={RouterLink}>Kontakt</Link>
    <Link variant="h6" to={ROUTES.PRICING} component={RouterLink}>Ceník</Link>
    <Link variant="h6" to={ROUTES.FAQ} component={RouterLink}>FAQ</Link>
    <Link variant="h6" to={ROUTES.TERMS_AND_CONDITIONS} component={RouterLink}>VOP</Link>
    <Link variant="h6" to={ROUTES.PRIVACY_POLICY} component={RouterLink}>Zásady zpracování osobních údajů</Link>
    <Link variant="h6" to={ROUTES.LOGIN} component={RouterLink}>Přihlášení</Link>
    {/* <Link variant="h6" href={ROUTES.FAQ}>Podmínky používání</Link> */}
    {/* <Link variant="h6" href={ROUTES.FAQ}>Zásady ochrany osobních údajů</Link> */}
  </Stack>)
};

const Footer = () => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.primary.main,
        backgroundImage: `url(${BubbleOverlay})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "80%",
        backgroundPosition: "50% 35%",
        py: 4,
        pb: 1,
        px: 6,
        color: "#fff",
        zIndex: 2,
        position: 'relative',
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        [theme.breakpoints.down("lg")]: {
          px: 2,
        },
        [theme.breakpoints.down("md")]: {
          zIndex: 200,
        },
      }}
      id={"footer"}
    >
      <Stack
        direction={"row"}
        sx={{
          justifyContent: "space-between",
          [theme.breakpoints.down("lg")]: {
            justifyContent: "center",
            gap: 2,
          },
          [theme.breakpoints.down("md")]: {
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          },
        }}
      >
        <Stack
          direction={"column"}
          sx={{
            gap: theme.spacing(2),
            [theme.breakpoints.down("md")]: {
              gap: 1,
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
              "& > img": {
                width: 175,
              }
            },
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          }}
        >
          <img
            width="200"
            src={SMSServicesLogo}
            alt="Work in progress"
            style={{ padding: "5px" }}
          />
        </Stack>
        {!isMedium && <FooterImportantLinksBlock />}
        <Stack direction={"row"} sx={{
          gap: 6,
          "* > a": {
            color: "white",
            fontWeight: 300,
            [theme.breakpoints.down("sm")]: {
              textAlign: "center",
            }
          },
          [theme.breakpoints.down("lg")]: {
            gap: 1.5,
          },
          [theme.breakpoints.down("md")]: {
            gap: 1,
          },
          [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          },
        }}>

          {isMedium && <FooterImportantLinksBlock />}
          <Stack
            direction={"column"}
            sx={{
              gap: 1,
              alignSelf: "flex-end",
              [theme.breakpoints.down("lg")]: {
                gap: 0,
                alignSelf: "normal",
              },
              [theme.breakpoints.down("sm")]: {
                justifyContent: "center",
                alignItems: "center",
              },
            }}
          >
            <Typography variant="h5" fontWeight={"600"}>
              Sledujte nás
            </Typography>
            <Stack direction={"row"} gap={2} sx={{
              gap: 2,
              [theme.breakpoints.down("lg")]: {
                gap: 1,
              },
            }}>
              <Link href={"https://www.facebook.com/smssluzby"} target="_blank" rel="noopener noreferrer"><FacebookIcon /></Link>
              {/* <Link href={"https://www.twitter.com/"}><XIcon /></Link> */}
              {/* <Link href={"https://www.linkedin.com/"}><LinkedInIcon /></Link> */}
            </Stack>
          </Stack>
          <Stack direction={"column"} rowGap={0.5} sx={{
            alignSelf: 'flex-end',
            [theme.breakpoints.down("sm")]: {
              justifyContent: "center",
              alignItems: "center",
              alignSelf: 'normal',
              "& > * > .MuiTypography-root": {
                textAlign: "center",
              }
            },
          }}>
            <Stack direction={"column"} lineHeight={0}>
              <Typography>SMS-služby s.r.o.</Typography>
              <Typography>Národní 973/41</Typography>
              <Typography>110 00 Praha 1 - Staré Město</Typography>
            </Stack>
            <Stack direction={{ xs: "column", sm: "row" }} gap={2} mt={1} alignItems={{ xs: "center", sm: "flex-start" }}>
              <Stack direction={"column"} gap={0.5}>
                <Typography variant="body2" fontWeight={500}>Koordinátor služby:</Typography>
                <Typography variant="body2">RNDr. Marek Komárek, Ph.D.</Typography>
                <Stack direction={"row"} gap={1} mt={0.5}>
                  <PhoneInTalkIcon fontSize="small" />
                  <Link href={"tel:+420725983171"}>+420 725 983 171</Link>
                </Stack>
                <Stack direction={"row"} gap={1}>
                  <EmailIcon fontSize="small" />
                  <Link href={"mailto:marek.komarek@sms-sluzby.cz"}>marek.komarek@sms-sluzby.cz</Link>
                </Stack>
              </Stack>

            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Typography variant="caption">
          <a href="https://appnificent.dev" style={{ color: '#fff', textDecoration: 'none' }} target="_blank">Appnificent © {new Date().getFullYear()}</a>
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer;
